import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import MainLayout from 'layouts/main'
import definitionTagService, {
  DefinitionTag,
  UpdateDefinitionTagRequest,
} from 'services/http/backoffice/definition-tag'

import { UpdateDefinitionTagProps } from './types'
import DefinitionTagForm from './DefinitionTagForm'

const UpdateDefinitionTag: React.FunctionComponent<UpdateDefinitionTagProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [definitionTag, setDefinitionTag] = useState<DefinitionTag>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = match.params.id

      definitionTagService
        .getById(id)
        .then((res) => {
          setDefinitionTag(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateDefinitionTagRequest) => {
      if (data) {
        setIsLoading(true)

        definitionTagService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleDelete = () => {
      definitionTagService
        .remove(match.params.id)
        .then(() => {
          flagcard.add({
            id: uid(),
            appearance: 'success',
            title: 'İşlem Başarılı',
            children: 'Geçerli veri, sistem üzerinde başarıyla silinmiştir.',
          })
          history.push('/definition-tag')
        })
        .catch((error) => {
          console.log(error)

          flagcard.add({
            id: uid(),
            appearance: 'error',
            title: 'Hata Oluştu',
            children:
              'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Tanımlama etiketi" href="/definition-tag" />
        <BreadcrumbItem text="Tanımlama etiketi güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              actions={
                <Button onClick={() => handleDelete()} appearance="error">
                  Tanımlama etiketini sil
                </Button>
              }
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli tanımlama etiketini
                  güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor: {definitionTag ? definitionTag.name : null}
            </PageHeader>
            <DefinitionTagForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/definition-tag">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              values={definitionTag}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateDefinitionTag
